angular.module("app").filter("hasChild", [
    'settingsService',
    function (settingsService) {
        return function (input) {
            var settings = settingsService.getSettings();
            if(settings && settings.allowActions)
            if (settings.allowActions.indexOf("configTreeAdd") + settings.allowActions.indexOf("configTreeChange") > -2) {
                return input
            }
            if (input && input.length) {
                var i = 0,
                    childes = [];
                while (input[i]) {
                    if (input[i].child) {
                        childes.push(input[i])
                    }
                    i++;
                }
                if (childes.length) {
                    return childes
                }
                return false
            }
            return false
        }
    }
]).filter("onlyChildes", [
    function () {
        return function (input) {
            if (input && input.length) {
                var i = 0,
                    childes = [];
                while (input[i]) {
                    if (!input[i].child) {
                        childes.push(input[i])
                    }
                    i++;
                }
                if (childes.length) {
                    return childes
                }
                return false
            }
            return false
        }
    }
]);